<template>
    <div class="dd-m-auth dd-m-auth--recovery-success">
        <div class="dd-m-auth__content">
            <h2 class="dd-m-auth__title">Your message<br/>was sent—</h2>

            <div class="dd-m-form--auth__description">
                <p>
                    We sent an email to {{email}}. Verifique sua caixa de entrada para mais instruções de como
                    recuperar sua senha.
                </p>
            </div>

            <button type="button"
                    v-on:click="back()"
                    class="dd-m-auth__back-btn dd-m-button dd-m-button--default dd-m-button--assertive">
                Back
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'auth-success',
        props: ['email'],
        mounted() {
        },
        methods: {
            back() {
                PubSub.publish('openLoginModal');

                setTimeout(() => {
                    PubSub.publish('closeRecoveryModal');
                    PubSub.publish('updateRecoveryStep', {step: 1});
                }, 100);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-success.vue